const dic = {
  // 银行类型
  bank_type: [
    {
      dictionaryName: '兴业',
      dictionaryValue: 0
    },
    {
      dictionaryName: '建设',
      dictionaryValue: 1
    }
  ],
  // 银行卡-卡类型
  bank_card_type: [
    {
      dictionaryName: '信用卡',
      dictionaryValue: 1
    },
    {
      dictionaryName: '借记卡',
      dictionaryValue: 2
    }
  ],
  // 支付方式
  payment_method: [
    {
      dictionaryName: '微信支付',
      dictionaryValue: 0
    }
  ],
  // 跳转类型
  jumpType: [
    {
      dictionaryName: '无',
      dictionaryValue: 0
    },
    {
      dictionaryName: '跳转H5页面',
      dictionaryValue: 1
    },
    {
      dictionaryName: '跳转小程序',
      dictionaryValue: 2
    }
  ],
  // 微站商品展示位置
  site_product_location: [
    {
      dictionaryName: '服务模块',
      dictionaryValue: 0
    },
    {
      dictionaryName: '限量抢购',
      dictionaryValue: 1
    },
    {
      dictionaryName: '大牌权益',
      dictionaryValue: 2
    },
    {
      dictionaryName: '精选好物',
      dictionaryValue: 3
    }
  ],
  // 商品展示类型
  product_type: [
    {
      dictionaryName: '支付券',
      dictionaryValue: 0
    },
    {
      dictionaryName: '消费券',
      dictionaryValue: 1
    },
    {
      dictionaryName: '直充',
      dictionaryValue: 2
    }
  ],
  // 商品展示分类(微站)
  product_category: [
    {
      dictionaryName: '微信',
      dictionaryValue: 0
    },
    {
      dictionaryName: '支付宝',
      dictionaryValue: 1
    },
    {
      dictionaryName: '云闪付',
      dictionaryValue: 2
    },
    {
      dictionaryName: '美团',
      dictionaryValue: 3
    },
    {
      dictionaryName: '话费充值',
      dictionaryValue: 4
    },
    {
      dictionaryName: '商超购物',
      dictionaryValue: 5
    },
    {
      dictionaryName: '电商消费',
      dictionaryValue: 6
    },
    {
      dictionaryName: '餐饮美食',
      dictionaryValue: 7
    },
    {
      dictionaryName: '生活服务',
      dictionaryValue: 8
    },
    {
      dictionaryName: '影音娱乐',
      dictionaryValue: 9
    },
    {
      dictionaryName: '游戏直播',
      dictionaryValue: 10
    },
    {
      dictionaryName: '其他',
      dictionaryValue: 11
    }
  ],
  orderStatus: [
    {
      dictionaryName: '待付款',
      dictionaryValue: 1
    },
    {
      dictionaryName: '待发货',
      dictionaryValue: 2
    },
    {
      dictionaryName: '已完成',
      dictionaryValue: 3
    },
    {
      dictionaryName: '已取消',
      dictionaryValue: 4
    },
    {
      dictionaryName: '退款成功',
      dictionaryValue: 5
    },
    {
      dictionaryName: '退款失败',
      dictionaryValue: 6
    },
    {
      dictionaryName: '退款中',
      dictionaryValue: 7
    },
    {
      dictionaryName: '拼团中',
      dictionaryValue: 8
    },
  ]

}

// 商品展示分类-支付券(微站,商品库)
dic.product_category_payment_voucher = dic.product_category.filter(i =>
  [0, 1, 2, 3].includes(i.dictionaryValue)
)
// 商品展示分类-消费券(微站)
dic.product_category_consumer_coupon = dic.product_category.filter(i =>
  [5, 6, 7, 8, 9, 11].includes(i.dictionaryValue)
)
// 商品展示分类-直充(微站)
dic.product_category_direct_charging = dic.product_category.filter(i =>
  [4, 5, 6, 7, 8, 9, 10, 11].includes(i.dictionaryValue)
)
export default dic
